import React from 'react'
import PopupBG from '../../assets/svg/popup-bg.svg';
import Modal from '../Modal'
import Button from '../Button';
const SuccessModal = props => {
    return (
        <Modal isOpen={false} closeTrigger={() => alert("write close function here")}>
                <div className="py-16 px-4" >
                    <img src={PopupBG} className="absolute right-0 top-0 h-full -mr-px" alt="" />
                    <div >
                        <h4 className="text-4xl font-bold mb-4">Your query has been submitted!</h4>
                        <p>Our team will be in touch forthwith.</p>
                        <div className="w-9/12 mt-14">
                            <div className="text-center font-bold mb-4">Choose what you want to do next:</div>
                            <div className="flex  justify-between mb-4">
                                <div className="text-center border-r border-vp-lightbrown pr-4 w-2/5 flex-shrink-0">
                                    <Button btnStyle="primary-outline" extraClasses="w-full" text="Go back to Dashboard" />
                                    <div className="px-2 mt-6">
                                        Your results are permanently stored in your personalized dashboard. Use the link from the email to go back to it anytime.
                                    </div>
                                </div>
                                <div className=" px-4">
                                    <div className="flex items-end whitespace-nowrap">
                                        <input type="password" placeholder="*******" className="mr-2 border-b-2 italic p-2 border-black text-sm focus:outline-none mr-2" />
                                        <Button btnStyle="primary" text="Create account" />
                                    </div>
                                    <div className="mt-6">You can create password protected account. With this solution you can share the results within your team.</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
    )
}


export default SuccessModal
